import { ECoworkingOfferType } from '@cian/api-models/offer-card/v1/get-offer-data';

import { ICommercialParams } from '../presenter/commercial';
import { IOffer } from '../types/offer';

const coworkingOfferTypeTitle = {
  flexOffice: 'Отдельный офис',
  fixedWorkplace: 'Закреплённое рабочее место',
  flexibleWorkplace: 'Незакреплённое рабочее место',
  conferenceHall: 'Конференц-зал',
  meetingRoom: 'Переговорная комната',
  office: 'Офис',
};

export function getCommercialCoworkingTitle(
  { coworkingOfferType }: IOffer,
  defaultTitle: string,
  params: ICommercialParams = {},
) {
  const {
    isOfficeSearch = false,
    isOfficeInCoworkingTitleVisible = false,
    isFlexOfficeCardSameAsOffice = false,
  } = params;

  if (!coworkingOfferType) {
    return defaultTitle;
  }

  if (coworkingOfferType === ECoworkingOfferType.Office) {
    if (isFlexOfficeCardSameAsOffice) {
      return defaultTitle;
    }

    if (isOfficeInCoworkingTitleVisible) {
      return 'Офис в коворкинге';
    }

    return isOfficeSearch ? coworkingOfferTypeTitle.office : coworkingOfferTypeTitle.flexOffice;
  }

  return coworkingOfferTypeTitle[coworkingOfferType] || defaultTitle;
}
